import React from 'react';
import cn from 'classnames';
import { useOptions, useIsInternalUser, useIsOwnerRecord } from 'helper/hooks';
import {
  Section as ElementSection,
  FormSection,
  ListInfo,
  Title,
} from 'views/pages/ClientDetail/components/Elements';
import SecurityField from 'components/SecurityField';
import InputItem from 'views/pages/ClientDetail/components/InputItem';
import InputItemEmpty from 'views/pages/ClientDetail/components/InputItem/Empty';
import { filteredClassOptions } from '../../utils';
import { DRIVER_LICENSE_OBJ_KEYS } from '../../constants';
import classes from './Section.module.scss';

const DriverLicense = ({ className, isEdit, form, data, clientId, isNew }) => {
  const {
    stateOptions,
    scClassOptions,
    scEndorsementOptions,
    scRestrictionOptions,
  } = useOptions();
  const { isInternalUser, isExternalOwner } = useIsInternalUser();
  const isOwnerRecord = useIsOwnerRecord(data?.id);

  return (
    <div className={cn(classes.driverLicenseSection, className)}>
      <Title text="Driver’s License" />
      <ElementSection className={classes.elSection}>
        {isEdit ? (
          <FormSection className={classes.elForm}>
            {isInternalUser ? (
              <SecurityField
                className={classes.securityField1}
                fieldObj={{
                  label: 'Driver’s License #',
                  value: '********',
                  type_id: data?.id,
                  type: 'official',
                  company_id: clientId,
                  key: 'dl_number',
                  alwaysDisplayView: isNew,
                }}
                viewRender={isShow => {
                  return (
                    <InputItem
                      name={'dl_number'}
                      label="Driver’s License #"
                      form={form}
                      addressGroupField
                      hide={!isShow}
                    />
                  );
                }}
                pinSuccessCb={val => {
                  form.setFieldsValue({
                    dl_number: val,
                  });
                }}
              />
            ) : isExternalOwner || isOwnerRecord ? (
              <InputItem
                name={'dl_number'}
                label="Driver’s License #"
                form={form}
                addressGroupField
              />
            ) : (
              <InputItemEmpty addressGroupField />
            )}
            <InputItem
              name={'dl_state_id'}
              label="State"
              form={form}
              type="select"
              options={stateOptions}
              addressGroupField
            />
            <InputItem
              name={'driver_license'}
              label="Driver’s License"
              form={form}
              type="file"
            />
            <InputItem
              name={'dl_expiration_date'}
              label="Expiration Date"
              form={form}
              type="date"
            />
            <InputItem
              name={'class_id'}
              label="Class"
              form={form}
              type="select"
              options={filteredClassOptions(scClassOptions)}
              optionLabelProp="label"
            />
            <InputItem
              name={'endorsements'}
              label="Endorsements"
              form={form}
              className="custom-select-width-10"
              type="select"
              options={scEndorsementOptions}
              mode="multiple"
              isMultipleOptionCheckbox
            />
            <InputItem
              name={'restrictions'}
              label="Restrictions"
              form={form}
              className="custom-select-width-12"
              type="select"
              options={scRestrictionOptions}
              mode="multiple"
              isMultipleOptionCheckbox
            />
          </FormSection>
        ) : (
          <ListInfo
            objKeys={DRIVER_LICENSE_OBJ_KEYS}
            data={data}
            sType="official"
            sCompanyId={clientId}
            needSecure
          />
        )}
      </ElementSection>
    </div>
  );
};

export default DriverLicense;
